import { getCurrentUser } from './auth';

export const createGoogleDoc = async (title: string, content: string) => {
  const user = getCurrentUser();
  if (!user) throw new Error('User not authenticated');

  // Instead of direct API integration, create a data URL for the content
  const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${title}</title>
  <style>
    body { font-family: system-ui, -apple-system, sans-serif; max-width: 800px; margin: 2rem auto; padding: 0 1rem; }
    h1, h2 { color: #f59e0b; }
    pre { background: #f3f4f6; padding: 1rem; border-radius: 0.5rem; }
  </style>
</head>
<body>
  <h1>${title}</h1>
  ${content.split('\n').map(line => `<p>${line}</p>`).join('\n')}
</body>
</html>`;

  const blob = new Blob([htmlContent], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  
  // Open Google Drive in a new tab
  const driveUrl = `https://drive.google.com/drive/my-drive`;
  window.open(driveUrl, '_blank');
  
  // Download the file locally
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title}.html`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);

  // Return a placeholder ID since we're not actually creating a Google Doc
  return 'local-export';
};